module.exports = __webpack_public_path__ + "img/timeline_event-18.189bcd85.jpg";